//action
import{
    SEND_SIGN_UP_REQUEST,
    SEND_SIGN_UP_REQUEST_FAIL,
    SEND_SIGN_UP_REQUEST_SUCCESS,
    SEND_SIGN_UP_REQUEST_RESET
} from "../action/sendSignUpRequestAction"
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SEND_SIGN_UP_REQUEST:
            return {
                ...state,
                apiState: "loading"
            }
        case SEND_SIGN_UP_REQUEST_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SEND_SIGN_UP_REQUEST_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data,
                message: action.response && action.response.data && action.response.data.message || api_err_msg
            }
        case SEND_SIGN_UP_REQUEST_RESET:
            return initialState    
        default:
            return state
        }
}